// @ts-nocheck

import { createContext, useContext } from 'react';

import { type BoomStepStatus } from '../types/steps';

type BoomStepContextProps = {
  stepId: string;
  stepStatus: BoomStepStatus;
};

export const BoomStepContext = createContext<BoomStepContextProps>({});

export const useBoomStepContext = () => useContext(BoomStepContext);
